import * as _ from 'lodash'

/*
 * Actions
 */

const ACTION_PREFIX = 'orgamax/businessPartner/detail'
const SET_BUSINESS_PARTNER_DATA = `${ACTION_PREFIX}/SET_BUSINESS_PARTNER_DATA`
const CLEAN_UP_BUSINESS_PARTNER_DATA = `${ACTION_PREFIX}/CLEAN_UP_BUSINESS_PARTNER_DATA`

/*
 * Reducer
 */
const initialState = {
  isLoading: false,
  errorOccurred: false,
  businessPartnerData: {},
}

export default function reducer(state = initialState, action) {
  const { businessPartnerData } = action

  switch (action.type) {
    case CLEAN_UP_BUSINESS_PARTNER_DATA:
      return Object.assign({}, initialState)

    case SET_BUSINESS_PARTNER_DATA:
      return Object.assign({}, state, {
        businessPartnerData,
      })

    default:
      return state
  }
}

/*
 * Action Creators
 */

const setData = (data) => {
  return {
    type: SET_BUSINESS_PARTNER_DATA,
    businessPartnerData: data,
  }
}

const cleanUp = () => {
  return {
    type: CLEAN_UP_BUSINESS_PARTNER_DATA,
  }
}

export const setBusinessPartnerData = (data) => {
  return dispatch => {
    dispatch(setData(data))
  }
}

export const cleanUpBusinessPartnerData = () => {
  return dispatch => {
    dispatch(cleanUp())
  }
}
